import axios from "axios";

export default {
    methods: {
        fetchBarrelDetails: async function (barrelId) {
            const getBarrelDetails = `${process.env.VUE_APP_URL}Barrel/GetBarrelsDetailsById/${barrelId}`;
            return axios.get(getBarrelDetails)
        },

        editCoatingProductInBarell: async function(coatingProductId,recipeCoatingId,ingredients) {
            const url = `${process.env.VUE_APP_URL}Barrel/EditCoatingProduct/`;
            return axios.post(url,{
                coatingProductId,
                recipeCoatingId,
                ingredients
            });
        }
    },
};
